import TextInput from "components/common/custom/forms/BootTextField/TextField";
import FalconCloseButton from "components/common/FalconCloseButton";
import MultiSelect from "components/common/MultiSelect";
import React, { useEffect, useMemo, useRef } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { nationalityData } from "../../practitioner/utils";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { GetIndividualBranch } from "../config/branchApi";
import { branchList, cityList } from "../utils";
const isEnglish = (value) => /^[A-Za-z0-9\s'-]+$/.test(value);

const isArabic = (value) => /^[\u0600-\u06FF\s]+$/.test(value);

const EditBranchModal = ({
  show,
  onHide,
  rowData,
  updateRowData,
  setSelectedRow,
}) => {
  const {
    watch,
    handleSubmit,
    reset,
    setValue,
    control,
    isSubmitted,
    formState: { errors },
  } = useForm();
  const prevRowNum = useRef(null);
  const getValueFromTitle = (dataList, title) => {
    if (!title) return "";
    const normalized = title?.trim().toLowerCase();
    const match = dataList.find(
      (item) => item.title?.trim().toLowerCase() === normalized
    );
    return match ? match.value : title;
  };

  useEffect(() => {
    if (!show) {
      reset();
      setSelectedRow(null);
      prevRowNum.current = null;
    }
  }, [show, reset, setSelectedRow]);

  useEffect(() => {
    if (show && rowData && prevRowNum.current !== rowData.rowNum) {
      setValue("branch_name_eng", rowData?.["Branch Name (Eng)"] || "");
      setValue("branch_name_arabic", rowData?.["Branch Name (Arabic)"] || "");
      setValue("mobile_no", rowData?.["Phone No."] || "");

      setValue(
        "branch_type",
        rowData?.branch_type ||
          branchList?.find((item) => item?.title === rowData?.["Branch Type"])
      );

      setValue("cchi_no", rowData?.["CHI No"] || "");
      setValue("nphies_id", rowData?.["Nphies ID"] || "");
      setValue("vat_no", rowData?.["VAT No"] || "");
      setValue("cr_no", rowData?.["CR No"] || "");
      setValue("building_no", rowData?.["Building No"] || "");
      setValue("unit_no", rowData?.["Unit No"] || "");
      setValue("street_name", rowData?.["Street Name"] || "");
      setValue("district", rowData?.["District"] || "");
      setValue("zip_code", rowData?.["Zip Code"] || "");
      setValue(
        "city",
        rowData?.City?.value
          ? rowData?.City
          : cityList?.find((item) => item?.title === rowData?.["City"]) || ""
      );

      // Provider Codes
      setValue("provider_code_bupa", rowData?.["Bupa"] || "");
      setValue("provider_code_tawuniya", rowData?.["Tawuniya"] || "");
      setValue("provider_code_medgulf", rowData?.["MedGulf"] || "");
      setValue("provider_code_malath", rowData?.["Malath"] || "");
      setValue("provider_code_saico", rowData?.["SAICO"] || "");
      setValue("provider_code_sabb", rowData?.["SABB"] || "");
      setValue("provider_code_gulf_union", rowData?.["Gulf Union"] || "");
      setValue("provider_code_alrajhi", rowData?.["Alrajhi Takaful"] || "");
      setValue("provider_code_gig", rowData?.["Gulf Insurance Group"] || "");
      setValue("provider_code_wataniyarn", rowData?.["Wataniyarn"] || "");
      setValue("provider_code_medivisarn", rowData?.["Medivisarn"] || "");
      setValue("provider_code_tcs", rowData?.["TCS"] || "");
      setValue("provider_code_globemed", rowData?.["Globemed"] || "");
      setValue("provider_code_nextcare", rowData?.["Nextcare"] || "");
      setValue("provider_code_al_etihad", rowData?.["Al-Etihad"] || "");
      setValue("provider_code_mednet", rowData?.["MedNet"] || "");

      const nationalityValue = getValueFromTitle(
        nationalityData,
        rowData["Nationality"]
      );

      setValue(
        "country",
        nationalityData?.find((item) => item?.title === rowData?.["Country"])
      );
    }
  }, [show, rowData, setValue]);

  const handleFormSubmit = (data) => {
    const formattedData = {
      ...data,
      "CHI No": data?.cchi_no || "",
      "Branch Name (Eng)": data.branch_name_eng || "",
      "Branch Name (Arabic)": data.branch_name_arabic || "",
      "Phone No.": data.mobile_no || "",
      "Branch Type": data.branch_type?.label || "",
      "Nphies ID": data.nphies_id || "",
      "VAT No": data.vat_no || "",
      "CR No": data.cr_no || "",
      "Building No": data.building_no || "",
      "Additional No": data.additional_no || "",
      "Unit No": data.unit_no || "",
      "Street Name": data.street_name || "",
      District: data.district || "",
      "Zip Code": data.zip_code || "",
      City: data.city || "",
      Country: data.country?.title || "",

      // Provider Codes
      Bupa: data.provider_code_bupa || "",
      Tawuniya: data.provider_code_tawuniya || "",
      MedGulf: data.provider_code_medgulf || "",
      Malath: data.provider_code_malath || "",
      SAICO: data.provider_code_saico || "",
      SABB: data.provider_code_sabb || "",
      "Gulf Union": data.provider_code_gulf_union || "",
      "Alrajhi Takaful": data.provider_code_alrajhi || "",
      "Gulf Insurance Group": data.provider_code_gig || "",
      Wataniyarn: data.provider_code_wataniyarn || "",
      Medivisarn: data.provider_code_medivisarn || "",
      TCS: data.provider_code_tcs || "",
      Globemed: data.provider_code_globemed || "",
      Nextcare: data.provider_code_nextcare || "",
      "Al-Etihad": data.provider_code_al_etihad || "",
      MedNet: data.provider_code_mednet || "",
    };

    const isValid = Object.keys(errors).length === 0;

    updateRowData(rowData.rowNum, formattedData, isValid);
    reset();
    onHide();
    setSelectedRow(null);
  };

  return (
    <Modal show={show} size="lg" centered>
      <Modal.Header>
        <Modal.Title className="fs-9">Edit Branch </Modal.Title>
        <FalconCloseButton
          onClick={() => {
            reset();
            onHide();
            setSelectedRow(null);
          }}
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
        />
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(handleFormSubmit)}>
          <Row>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="branch_name_eng"
                label="Branch Name (English)"
                placeholder="Branch Name (English)"
                control={control}
                errors={errors}
                required={true}
                size="sm"
                rules={{
                  validate: (v) =>
                    isEnglish(v) || "Must be English letters only",
                }}
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="branch_name_arabic"
                label="Branch Name (Arabic)"
                placeholder="Branch Name (Arabic)"
                control={control}
                errors={errors}
                size="sm"
                rules={{
                  validate: (v) =>
                    !v || isArabic(v) || "Must be Arabic letters only",
                }}
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="mobile_no"
                label="Mobile No."
                control={control}
                placeholder="05xxxxxxxx"
                size="sm"
                errors={errors}
                rules={{
                  validate: (v) =>
                    !v ||
                    /^05\d{8}$/.test(v) ||
                    "Mobile number must start with 05 and be 10 digits",
                }}
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <label className="form-label">
                Branch Type <span className="text-danger">*</span>
              </label>
              <Controller
                name="branch_type"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    options={branchList?.map((item) => ({
                      value: item?.value,
                      label: item?.title,
                    }))}
                    isClearable={true}
                    value={
                      field.value
                        ? {
                            value: field.value.value,
                            label: field.value.title,
                          }
                        : null
                    }
                    className={classNames({
                      "is-invalid":
                        errors.branch_type ||
                        (isSubmitted && !watch("branch_type")),
                    })}
                    onChange={(selected) => {
                      setValue(
                        "branch_type",
                        selected
                          ? {
                              value: selected.value,
                              title: selected.label,
                            }
                          : null
                      );
                    }}
                    formatOptionLabel={({ label }) => <div>{label}</div>}
                    placeholder="Choose ..."
                  />
                )}
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="cchi_no"
                label="CCHI No"
                placeholder="CCHI No"
                control={control}
                errors={errors}
                size="sm"
                required={true}
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="nphies_id"
                label="Nphies ID"
                placeholder="Nphies ID"
                control={control}
                errors={errors}
                size="sm"
                required={true}
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="vat_no"
                label="Vat No"
                placeholder="Vat No"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="cr_no"
                label="CR No"
                placeholder="CR No"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="building_no"
                label="Building No"
                placeholder="Building No"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="additional_no"
                label="Additional No"
                placeholder="Additional No"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="unit_no"
                label="Unit No"
                placeholder="Unit No"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="street_name"
                label="Street Name"
                placeholder="Street Name"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="district"
                label="District"
                placeholder="District"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="zip_code"
                label="Zip Code"
                placeholder="Zip Code"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <label className="form-label">City</label>
              <Controller
                name="city"
                control={control}
                rules={{ required: false }}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    options={cityList?.map((item) => ({
                      value: item?.value,
                      label: item?.title,
                    }))}
                    isClearable={true}
                    value={
                      field.value
                        ? {
                            value: field.value.value,
                            label: field.value.title,
                          }
                        : null
                    }
                    className={classNames({
                      "is-invalid":
                        errors.city || (isSubmitted && !watch("city")),
                    })}
                    onChange={(selected) => {
                      setValue(
                        "city",
                        selected
                          ? {
                              value: selected.value,
                              title: selected.label,
                            }
                          : null
                      );
                    }}
                    formatOptionLabel={({ label }) => <div>{label}</div>}
                    placeholder="Choose ..."
                  />
                )}
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <label className="form-label mb-2">Country</label>
              <Controller
                name="country"
                control={control}
                rules={{ required: false }}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    options={nationalityData?.map((item) => ({
                      value: item.value,
                      label: item.title,
                    }))}
                    isClearable={true}
                    value={
                      field.value
                        ? {
                            value: field.value.value,
                            label: field.value.title,
                          }
                        : null
                    }
                    onChange={(selected) => {
                      setValue(
                        "country",
                        selected
                          ? {
                              value: selected.value,
                              title: selected.label,
                            }
                          : null
                      );
                    }}
                    formatOptionLabel={({ label }) => <div>{label}</div>}
                    getOptionValue={(option) => option.value}
                    placeholder="Choose ..."
                  />
                )}
              />
            </Col>

            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_bupa"
                label="Provider Code Bupa"
                placeholder="Provider Code Bupa"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_tawuniya"
                label="Provider Code Tawuniya"
                placeholder="Provider Code Tawuniya"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_medgulf"
                label="Provider Code MedGulf"
                placeholder="Provider Code MedGulf"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_malath"
                label="Provider Code Malath"
                placeholder="Provider Code Malath"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_saico"
                label="Provider Code Saico"
                placeholder="Provider Code Saico"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_sabb"
                label="Provider Code Sabb"
                placeholder="Provider Code Sabb"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_gulf_union"
                label="Provider Code Gulf Union"
                placeholder="Provider Code Gulf Union"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_alrajhi"
                label="Provider Code Alrajhi Takaful"
                placeholder="Provider Code Alrajhi Takaful"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_gig"
                label="Provider Code GIG"
                placeholder="Provider Code GIG"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_wataniyarn"
                label="Provider Code Wataniyarn"
                placeholder="Provider Code Wataniyarn"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_medivisarn"
                label="Provider Code Medivisarn"
                placeholder="Provider Code Medivisarn"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_tcs"
                label="Provider Code TCS"
                placeholder="Provider Code TCS"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_globemed"
                label="Provider Code Globemed"
                placeholder="Provider Code Globemed"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_nextcare"
                label="Provider Code Nextcare"
                placeholder="Provider Code Nextcare"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_al_etihad"
                label="Provider Code Al-Etihad"
                placeholder="Provider Code Al-Etihad"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="provider_code_mednet"
                label="Provider Code MedNet"
                placeholder="Provider Code MedNet"
                control={control}
                errors={errors}
                size="sm"
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-end mt-4">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => {
                reset();
                onHide();
                setSelectedRow(null);
              }}
              className="me-2"
            >
              Cancel
            </Button>
            <Button type="submit" size="sm" variant="primary">
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditBranchModal;
